import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { InlineBanner } from '@calendly/ui/components/inline-banner';
const bannerWrapperCss = "ba0qnds";
export const FreeRecapsInlineBannerView = ({
  usedRecaps,
  recapsQuota,
  onUpgrade = () => {}
}) => <div className={bannerWrapperCss}>
    <InlineBanner data-testid="free-recaps-inline-banner" variant="ai" isDismissible={false} message={HtmlParser(I18n.t('publisher.meeting_intelligence.free_recaps.usage', {
    used: usedRecaps,
    total: recapsQuota
  }))} primaryButton={{
    decoration: 'secondary-outline',
    label: I18n.t('publisher.meeting_intelligence.free_recaps.upgrade_button'),
    onClick: onUpgrade,
    responsive: false
  }} />
  </div>;

require("./free_recaps_inline_banner_view.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./free_recaps_inline_banner_view.js");